import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { INavigationTree } from '../../interfaces';

@Component({
  selector: 'lib-navigation-links-mobile-group',
  templateUrl: './navigation-links-mobile-group.component.html',
  styleUrls: ['./navigation-links-mobile-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, RouterModule],
})
export class NavigationLinksMobileGroupComponent {
  navigationTree = input.required<INavigationTree>();
  selectGroupId = output<number>();

  toggleIsSubGroupOpened(): void {
    this.selectGroupId.emit(this.navigationTree().id);
  }
}
